import React from "react";

import MessageAvatar from "components/MessageBubble/MessageAvatar";
import MessageWithLinks from "components/MessageWithLinks";
import SubmitButton from "components/SubmitButton";
import { Literals } from "shared/types";

interface LocationBasedConsentFormProps {
  message: string;
  onAccept: () => void;
  botAvatar: string;
  copyTexts: Literals;
}

const LocationBasedConsentForm: React.FC<LocationBasedConsentFormProps> = ({
  message,
  onAccept,
  botAvatar,
  copyTexts,
}) => {
  return (
    <div className="h-full p-1">
      <div className="flex max-w-full gap-2">
        <MessageAvatar
          isSent={false}
          isIframe={false}
          botAvatar={botAvatar}
          isLastMessage={false}
        />
        <div className="w-fit min-w-0">
          <div className="max-w-full break-words rounded-xl bg-surface px-4 py-2.5 text-sm text-dark">
            <MessageWithLinks message={message} isSent={false} />
            <SubmitButton
              isSubmitting={false}
              className="mt-3 rounded-lg text-xs"
              onClick={onAccept}
            >
              {copyTexts.consentAgreementAcceptButton}
            </SubmitButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationBasedConsentForm;
